module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAArklEQVRYR+2XOw7CQAxE38xCargg3AAqqBF0VMARcsGkR3y0BEhygBAKF5ZXXms9fluN2D0Kp/tRYmExtyBH6uR8Tm5qyXrnpjbp3XX72v7uezYYqmTKKWzF4XYSrD+DfyIgL8dr0XMWUAlmIwmos4CHGjW9GPQLWgKEgCAQBIJAEAgCQSAIBIEgEASCwF8QGM2aSVRifz1LXo1izcxFX3sOS7s1qQN7w9pQFmLzBEM6aFkXXN2NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/endImg.png
// module id = w7rU
// module chunks = 2